<mat-card class="bg-success mt-3" *ngIf="showWebsitePulishedSuccessfuly">
  <mat-card-content>
    <div class="publishMessage">Your Website Published Successfully!</div>
  </mat-card-content>
</mat-card>
<mat-card class="bg-warning mt-3" *ngIf="showWebsitePulishedInProgress">
  <mat-card-content>
    <div class="publishMessage">
      Please wait upto 5 minutes to publish the domain!
    </div>
  </mat-card-content>
</mat-card>
<!-- <mat-card class="bg-success mt-3" *ngIf="showCloudFrontIsSuccessful">
  <mat-card-content>
    <div class="publishMessage">Your domain is connected Successfully!</div>
  </mat-card-content>
</mat-card> -->

<mat-card class="bg-warning mt-3" *ngIf="sslAndProvisionProgressStatus">
  <mat-card-content>
    <div class="sslMessage">
      Your SSL configuration and provision is In Progress. Please come back and
      refresh the page after 30 Minutes!
    </div>
  </mat-card-content>
</mat-card>
<form
  [formGroup]="projectSettings.dnsForm"
  (ngSubmit)="projectSettings.submitDnsForm()"
  class="p-3"
  ngNativeValidate
>
  <p class="mt-2">
    <label for="domain-name text-center" class="fontCustom"
      >Domain Name <span class="ml-2 starIcon">*</span>
    </label>
  </p>
  <div class="input-container row text-center ml-0 my-3">
    <input
      type="text"
      id="domain-name"
      class="form-control col-10"
      placeholder="e.g:yourdomainname.com"
      formControlName="domain_name"
      #domain_name
      [readOnly]="hasRecords"
      required
      pattern="^[a-zA-Z0-9.\-]+\.(com|org|net|in|io|co|gov|us)$"
    />

    <!-- <mat-icon
      class="mt-2 ml-3 pointer"
      *ngIf="hasRecords"
      (click)="editModeIsEnabled = !editModeIsEnabled"
      >edit</mat-icon
    > -->

    <img
      [src]="getImagePath('domainName')"
      alt=""
      *ngIf="hasRecords"
      width="20px"
      height="20px"
      class="ml-3 mt-3 pointer"
      style="opacity: 0.6"
      [matTooltip]="
        textIsCopied.domainName
          ? 'Copied to clipboard'
          : ('Copy domain name' | trans)
      "
      (click)="onClickedCopy(domain_name.value, 'domainName')"
    />
    <br />
    <p
      trans
      class="col-10 mt-2 text-danger"
      *ngIf="projectSettings.showDomainIsUsed"
    >
      {{ projectSettings.project.domain_name }} is already used
    </p>
    <p trans class="col-10 mt-2" *ngIf="!showWebsitePulishedSuccessfuly">
      {{
        hasRecords
          ? ""
          : "Enter the exact domain name you want your projects to be accessible with."
      }}
    </p>
  </div>

  <p
    *ngIf="(showSSLIsSuccess || !hasRecords) && !showWebsitePulishedFinally"
    trans
    class="text-center"
  >
    You have not connected any domains yet. Please click on
    {{ hasRecords ? "Publish Domain" : "Config Domain" }} to continue.
  </p>
  <div class="row justify-content-center" *ngIf="showLoader && !hasRecords">
    <span class="m-5">
      <loading-indicator [isVisible]="true" class="small"></loading-indicator>
    </span>
  </div>

  <div class="row justify-content-center py-3" *ngIf="shouldShowButton">
    <div secondary-text>
      <button
        type="submit"
        color="primary"
        [disabled]="showSSLIsInProgress"
        mat-raised-button
        trans
      >
        {{ hasRecords ? "Publish Domain" : "Config Domain" }}
      </button>
    </div>
  </div>

  <mat-card class="custom-bg my-3 col-10" *ngIf="showCopyDnsSection">
    <mat-card-content>
      <div class="publishMessage">
        You can configure using any one of the following entries provided: CName
        or Nameservers. If you have emails configured with the Domain, you can
        enter only the CName entries without changing the name servers. Please
        follow the instructions given below
      </div>
    </mat-card-content>
  </mat-card>
  <ng-container *ngIf="!showSSLIsInProgress && hasRecords && !showSSLIsSuccess">
    <!-- first expansion panel -->
    <mat-accordion class="mt-3">
      <mat-expansion-panel
        class="mat-elevation-z0"
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header
          class="bg-lightGray col-md-10 p-4"
          style="height: 7rem"
        >
          <mat-panel-title style="font-size: 14px">
            Copy the DNS Nameservers and paste it in your domain setting. Expand
            to see more details
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row py-3">
          <p class="fontCustom py-2 px-0">Instructions to be followed:</p>
          <br /><br />
          <p>
            1. Log in to your domain registrar's website <br /><br />
            2.Access Your Domain Manager: <br />
            Once you're logged in, go to the "My Products" section, and then
            click on "Domains." This will take you to your Domain Manager.
            <br />
            <br />
            3.Select the Domain You Want to Update: <br />
            In the Domain Manager, find the domain for which you want to update
            the nameservers and click on it to select it. <br />
            <br /><br />
            4.Access the Nameservers Settings:
            <br />
            Within the domain settings, look for an option called "Manage DNS"
            or "Nameservers." Click on this option to access the nameservers
            settings for the selected domain.
            <br />
            <br />
            5.Choose Custom Nameservers:<br />
            By default, domain provider may be set to use their default
            nameservers. To use custom nameservers (such as those provided by
            your web hosting provider or another DNS service), select the option
            to set custom nameservers.
            <br />
            <br />
            6.Add or Edit Nameserver Information:
            <br />
            You'll see fields where you can enter the nameserver information.
            You typically need to enter at least two nameservers, and some
            domains may require up to four.
            <br />
            Enter the nameserver addresses provided by your hosting provider or
            DNS service. The format is usually something like "ns1.example.com"
            and "ns2.example.com."
            <br />
            Click the "Add Nameserver" or "Save" button to save your changes.
            <br />
            <br />
            7.Save Your Changes:
            <br />
            After entering the nameserver information, make sure to save your
            changes. There should be a "Save" or "Update" button on the page.
            <br />
            <br />
            8.Propagation Time:
            <br />
            It's important to note that DNS changes can take some time to
            propagate across the internet, which can range from a few minutes to
            48 hours or more. During this period, your domain might resolve
            using either the old or new nameservers.
            <br />
            <br />
            9.Verify the Update:
            <br />
            You can verify that the nameserver update has taken effect by using
            online DNS lookup tools or by checking your hosting provider's
            dashboard.
            <br />
            <br />
            Once the nameserver update has fully propagated, your domain will be
            using the new nameservers you've specified.
            <br />
            <br />
            Keep in mind that if you're not sure what nameservers to use, you
            should contact your hosting provider or DNS service for the correct
            nameserver information. It's important to enter the nameserver
            information accurately to ensure your domain's proper functioning.
            <br />
            <br />
          </p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- dns recrods lists-->
    <mat-card class="mat-elevation-z3 p-3 mt-3 mb-2">
      <mat-card-content>
        <div
          class="info-step py-3"
          *ngIf="hasRecords && nameServerList.length > 0"
        >
          <!-- <p trans class="fontCustom ">
            <strong>Nameservers</strong>
          </p> -->
          <div class="row" *ngFor="let item of nameServerList; index as i">
            <p trans class="fontCustom py-2">Nameserver {{ i + 1 }}</p>
            <div class="row ml-0">
              <div class="message-widget">
                <div class="message">
                  <strong>{{ item.title }} </strong>
                </div>
              </div>
              <img
                [src]="getImagePathForNameServer(item)"
                alt=""
                width="20px"
                height="20px"
                class="ml-3 mt-3 pointer"
                style="opacity: 0.6"
                [matTooltip]="
                  item.isActive
                    ? 'Copied to clipboard'
                    : ('Copy name server' | trans)
                "
                (click)="onClickedCopyNameServer(item, i)"
              />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- second expansion panel -->
    <mat-accordion class="mt-3">
      <mat-expansion-panel
        class="mat-elevation-z0"
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header
          class="bg-lightGray col-md-10 p-4"
          style="height: 7rem"
        >
          <mat-panel-title style="font-size: 14px">
            Here 2 record types will be provided, you need to add both on your
            DNS settings.Copy the DNS details and paste it in your domain
            settings.
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row py-3">
          <p class="fontCustom py-2 px-0">Instructions to be followed:</p>
          <br /><br />
          <p>
            1. Log in to your domain registrar's website <br /><br />
            2.Access Your Domain Manager: <br />
            Once you're logged in, go to the "My Products" section, and then
            click on "Domains." This will take you to your Domain Manager.
            <br />
            <br />
            3.Select the Domain You Want to Update: <br />
            In the Domain Manager, find the domain for which you want to update
            the CName and click on it to select it. <br />
            <br /><br />
            4.Copy the details and create a record in your domain dns settings

            <br />
            <br />
            5.Check the Record type below e.g. 'CName'

            <br />
            <br />
            6.Copy the details and create a record in your domain dns settings
            <br />
            E.g is as follows:
            <br />
            Type: CName
            <br />
            Name: [Enter the name provided on the screen to which this record
            should apply]
            <br />
            Value: [Enter the value provided on the screen to you want to map
            the domain to]:
            <br />
            <br />

            7.Save Your Changes:
            <br />
            After entering the CName information, make sure to save your
            changes. There should be a "Save" or "Update" button on the page.
            <br />
            <br />
          </p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- ssl section -->
    <mat-card class="mat-elevation-z3 p-3 mt-3">
      <mat-card-content>
        <div class="info-step py-3" *ngIf="hasRecords">
          <div class="row">
            <p trans class="fontCustom py-2">Dns Record Type</p>
            <div class="row ml-0">
              <div class="message-widget">
                <div class="message">
                  <strong>{{ projectSettings.project.ssl_record_type }}</strong>
                </div>
              </div>
              <img
                *ngIf="projectSettings.project.ssl_record_type"
                [src]="getImagePath('dnsRecordType')"
                alt=""
                width="20px"
                height="20px"
                class="ml-3 mt-3 pointer"
                style="opacity: 0.6"
                [matTooltip]="
                  textIsCopied.dnsRecordType
                    ? 'Copied to clipboard'
                    : ('Copy dns record type' | trans)
                "
                (click)="
                  onClickedCopy(
                    projectSettings.project.ssl_record_type,
                    'dnsRecordType'
                  )
                "
              />
            </div>
          </div>
          <div class="row">
            <p trans class="fontCustom py-2">Dns Record Name</p>
            <div class="row ml-0">
              <div class="message-widget">
                <div class="message">
                  <strong>{{ projectSettings.project.ssl_record_name }}</strong>
                </div>
              </div>
              <img
                *ngIf="projectSettings.project.ssl_record_name"
                [src]="getImagePath('dnsRecordName')"
                alt=""
                width="20px"
                height="20px"
                class="ml-3 mt-3 pointer"
                style="opacity: 0.6"
                [matTooltip]="
                  textIsCopied.dnsRecordName
                    ? 'Copied to clipboard'
                    : ('Copy dns record name' | trans)
                "
                (click)="
                  onClickedCopy(
                    projectSettings.project.ssl_record_name,
                    'dnsRecordName'
                  )
                "
              />
            </div>
          </div>
          <div class="row">
            <p trans class="fontCustom py-22">Dns Record Value</p>
            <div class="row ml-0">
              <div class="message-widget">
                <div class="message">
                  <strong>{{
                    projectSettings.project.ssl_record_value
                  }}</strong>
                </div>
              </div>
              <img
                *ngIf="projectSettings.project.ssl_record_value"
                [src]="getImagePath('aRecord')"
                alt=""
                width="20px"
                height="20px"
                class="ml-3 mt-3 pointer"
                style="opacity: 0.6"
                [matTooltip]="
                  textIsCopied.aRecord
                    ? 'Copied to clipboard'
                    : ('Copy dns record value' | trans)
                "
                (click)="
                  onClickedCopy(
                    projectSettings.project.ssl_record_value,
                    'aRecord'
                  )
                "
              />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <!-- clound front section -->
    <mat-card class="mat-elevation-z3 mt-3">
      <mat-card-content>
        <div class="info-step py-3" *ngIf="hasRecords">
          <div class="row">
            <p trans class="fontCustom py-2">Dns Record Type</p>
            <div class="row ml-0">
              <div class="message-widget">
                <div class="message">
                  <strong>{{
                    projectSettings.project.cloudfront_record_type
                  }}</strong>
                </div>
              </div>
              <img
                *ngIf="projectSettings.project.cloudfront_record_type"
                [src]="getImagePath('cloudFrontRecordType')"
                alt=""
                width="20px"
                height="20px"
                class="ml-3 mt-3 pointer"
                style="opacity: 0.6"
                [matTooltip]="
                  textIsCopied.cloudFrontRecordType
                    ? 'Copied to clipboard'
                    : ('Copy dns record type' | trans)
                "
                (click)="
                  onClickedCopy(
                    projectSettings.project.cloudfront_record_type,
                    'cloudFrontRecordType'
                  )
                "
              />
            </div>
          </div>
          <div class="row">
            <p trans class="fontCustom py-2">Dns Record Name</p>
            <div class="row ml-0">
              <div class="message-widget">
                <div class="message">
                  <strong>{{
                    projectSettings.project.cloudfront_record_name
                  }}</strong>
                </div>
              </div>
              <img
                *ngIf="projectSettings.project.cloudfront_record_name"
                [src]="getImagePath('cloudFrontRecordName')"
                alt=""
                width="20px"
                height="20px"
                class="ml-3 mt-3 pointer"
                style="opacity: 0.6"
                [matTooltip]="
                  textIsCopied.cloudFrontRecordName
                    ? 'Copied to clipboard'
                    : ('Copy dns record name' | trans)
                "
                (click)="
                  onClickedCopy(
                    projectSettings.project.cloudfront_record_name,
                    'cloudFrontRecordName'
                  )
                "
              />
            </div>
          </div>
          <div class="row">
            <p trans class="fontCustom py-22">Dns Record Value</p>
            <div class="row ml-0">
              <div class="message-widget">
                <div class="message">
                  <strong>{{
                    projectSettings.project.cloudfront_record_value
                  }}</strong>
                </div>
              </div>
              <img
                *ngIf="projectSettings.project.cloudfront_record_value"
                [src]="getImagePath('cloudFrontRecordValue')"
                alt=""
                width="20px"
                height="20px"
                class="ml-3 mt-3 pointer"
                style="opacity: 0.6"
                [matTooltip]="
                  textIsCopied.cloudFrontRecordValue
                    ? 'Copied to clipboard'
                    : ('Copy dns record value' | trans)
                "
                (click)="
                  onClickedCopy(
                    projectSettings.project.cloudfront_record_value,
                    'cloudFrontRecordValue'
                  )
                "
              />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z0 mt-3">
      <mat-card-content>
        <div class="row p-2">
          <mat-checkbox
            class="example-margin"
            [checked]="agreeToDnsSettings"
            (change)="toggleCheckbox($event.checked)"
            >By Clicking this box, you agree that above details have been added
            to your DNS settings</mat-checkbox
          >
        </div>
        <div
          class="row justify-content-center"
          *ngIf="showLoader && hasRecords"
        >
          <span class="m-5">
            <loading-indicator
              [isVisible]="true"
              class="small"
            ></loading-indicator>
          </span>
        </div>
        <div class="row p-2 justify-content-center" *ngIf="agreeToDnsSettings">
          <button
            type="submit"
            color="primary"
            mat-raised-button
            (click)="
              projectSettings.updateDnsStatus(agreeToDnsSettings ? 1 : 0)
            "
            trans
          >
            Continue
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <div class="row justify-content-ceter px-5 mt-3">
    <div class="col-lg-5 p-0" *ngIf="showSSLIsInProgress">
      <div class="row">
        <span class="mr-5">
          <loading-indicator
            [isVisible]="true"
            class="small"
          ></loading-indicator>
        </span>

        <span class="fontCustom">SSL is in Progress</span>
      </div>
    </div>
    <div
      class="col-lg-5 p-0"
      *ngIf="showDistributionIsInProgress && !showCopyDnsSection"
    >
      <div class="row">
        <span class="mr-5">
          <loading-indicator
            [isVisible]="true"
            class="small"
          ></loading-indicator>
        </span>
        <span class="fontCustom">Provision is in progress</span>
      </div>
    </div>
  </div>
  <div class="row justify-content-ceter px-5 mt-3" *ngIf="showSSLIsSuccess">
    <div class="col-lg-5 p-0">
      <div class="row">
        <mat-icon style="color: green">check</mat-icon>
        <span class="fontCustom">SSL Configured Successfully</span>
      </div>
    </div>
  </div>
  <div
    class="row justify-content-ceter px-5 mt-3"
    *ngIf="showCloudFrontIsSuccessful"
  >
    <div class="col-lg-5 p-0">
      <div class="row">
        <mat-icon style="color: green">check</mat-icon>
        <span class="fontCustom">Provision Configured Successfully</span>
      </div>
    </div>
  </div>
</form>
